import React from 'react'

export const LoadingState: React.FC = () => (
  <div className="flex h-32 items-center justify-center text-sm text-gray-500">
    Loading data…
  </div>
)
